module.exports = __webpack_public_path__ + "img/westpex-logo.95450590.png";